<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yQ3BaA/tc-custom/9780802193933.jpg?1728954778371" alt="This image is the cover for the book Seven Days, Benny Griessel Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seven Days, Benny Griessel Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Detective Griessel must solve a cold case to stop a shooter in this thriller from the acclaimed South African author.</b><br/>  <br/> Two police officers have been shot, and the Cape Town homicide department has received emails from the shooter alleging the cover-up of an unsolved murder. If the cold case isn’t reopened immediately, the shooter’s carnage will continue.<br/>  <br/> Now Det. Capt. Benny Griessel is out to solve the crime in question: the murder of an ambitious lawyer stabbed to death in her luxury apartment. Unfortunately, there’s no apparent motive, forensic evidence, or leads.<br/>  <br/> As Griessel races to piece together an investigation with nothing to go on and his colleague, Capt. Mbali Kaleni, attempts to locate the shooter, a third cop becomes the victim of another barrage of bullets. The shooter is growing bolder by the day, and it’s only a matter of time before Griessel ends up in his sights . . .<br/>  <br/> “What makes Meyer such a national treasure—and as good as anyone in the world—is that even if you have no knowledge or interest in South Africa’s history or present, his books are compelling page-turners.” —<i>The Times</i> (London)<br/>  <br/> “Superior prose and characterization . . . reminiscent of Peter Lovesey at his twistiest.” —<i>Publishers Weekly</i><br/>  <br/> “Sleekly done crime fiction layered with the cultural complexities of the new South Africa.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deon Meyer
      </h2>
      
      <p class="authorDescription body article">Deon Meyer is an internationally acclaimed, prize-winning author of six crime novels, including <I>Heart of the Hunter, Dead at Daybreak,</I> and his latest, <I>Thirteen Hours</I>. His books have been translated into twenty languages. He lives on the western coast of South Africa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atlantic Monthly Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d8d7cb4